import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { ASSIGNEE_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { CardId, Person } from '../../../model/types.tsx';
import { type CardSetMeta, setCardSetMeta } from '../meta/card-set-meta.tsx';

export const CARD_ASSIGNEE_SET = 'state.actions.assignee.CARD_ASSIGNEE_SET';

export type CardAssigneeSetAction = {
	type: typeof CARD_ASSIGNEE_SET;
	payload: {
		cardId: CardId;
		assignee: Person | null;
	};
};

export const cardAssigneeSet = (
	cardId: CardId,
	assignee: Person | null,
): CardAssigneeSetAction => ({
	type: CARD_ASSIGNEE_SET,
	payload: {
		cardId,
		assignee,
	},
});

export const CARD_ASSIGNEE_SET_OPTIMISTIC =
	'state.actions.assignee.CARD_ASSIGNEE_SET_OPTIMISTIC' as const;

export type CardAssigneeSetOptimisticAction = {
	type: typeof CARD_ASSIGNEE_SET_OPTIMISTIC;
	payload: CardAssigneeSetAction['payload'];
	meta: CardSetMeta;
};

export const cardAssigneeSetOptimistic = (
	payload: CardAssigneeSetOptimisticAction['payload'],
	issueKey: IssueKey,
	analyticsEvent: UIAnalyticsEvent,
): CardAssigneeSetOptimisticAction => ({
	type: CARD_ASSIGNEE_SET_OPTIMISTIC,
	payload,
	meta: {
		...setCardSetMeta(
			{
				issueKey,
				fieldId: ASSIGNEE_TYPE,
				newValue: payload.assignee,
				retryAction: () => cardAssigneeSetOptimistic(payload, issueKey, analyticsEvent),
			},
			analyticsEvent,
		),
	},
});

export type Action = CardAssigneeSetAction | CardAssigneeSetOptimisticAction;
